<div class="feedback-list">
  @let feedbacks = feedbacks$ | async;
  @if (feedbacks) {
    <div class="feedback-list__content">
      <img src="assets/icons/sparkles.svg" alt="sparkles emoji" />
      <p class="feedback-text feedback-list__content-text">
        {{ feedbacks[currentIndex()].feedbackText | translate }}
      </p>
    </div>
    <div class="feedback-list__footer">
      <div class="feedback-list__author">
        <img
          [src]="feedbacks[currentIndex()].profilePhoto"
          alt="User Avatar"
          class="feedback-list__author-avatar"
        />
        <div class="feedback-list__author-info">
          <p class="feedback-md feedback-list__author-name">
            {{ feedbacks[currentIndex()].name }}
          </p>
          <p class="feedback-sm feedback-list__author-role">
            {{ feedbacks[currentIndex()].role }}, {{ feedbacks[currentIndex()].companyName }}
          </p>
        </div>
      </div>
      <div class="feedback-list__navigation">
        <button
          class="feedback-list__navigation-btn arrow-left"
          (click)="prevFeedback(feedbacks.length)"
        >
          <app-icon [icon]="iconName.ARROWLEFT" class="icon" />
        </button>
        <button
          class="feedback-list__navigation-btn arrow-right"
          (click)="nextFeedback(feedbacks.length)"
        >
          <app-icon [icon]="iconName.ARROWRIGHT" class="icon" />
        </button>
      </div>
    </div>
  }
</div>
